import React from 'react';
import { useTranslation } from 'react-i18next';

type SidebarHeaderProps = {
	title: string;
	buttonRight?: React.ReactNode;
};

export const SidebarHeader = ({ title, buttonRight }: SidebarHeaderProps) => {
	const { t } = useTranslation();
	return (
		<div className="p-2 px-4 flex justify-between">
			<div className="px-2 flex flex-col justify-center">
				<p className="font-poppins text-sm leading-5 text-tablz-text-gray-1 sm:hidden">{title}</p>
				<p className="text-tablz-text-white-1 font-lora text-[26px] leading-6 font-medium">{t('titles.find_availability')}</p>
			</div>
			<div>
				{buttonRight}
			</div>
		</div>
	);
};
